import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card, Input, Table } from "@/components/erp/ui";

const fmt = (n) => (Number.isInteger(n) ? n : n.toFixed(2));

// Rekap per konsultan per bulan: tamu, jadi quotation, jadi order (KPI dibagi rata bila berganti konsultan)
export const KonsultanRecap = () => {
  const [month, setMonth] = useState(new Date(Date.now() + 7 * 3600000).toISOString().slice(0, 7));
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/konsultan/recap", { params: { month } }).then(({ data }) => setD(data)).catch(() => {}); }, [month]);
  return (
    <Card className="p-4" data-testid="kons-recap">
      <div className="flex flex-wrap items-center gap-3 mb-3">
        <div className="font-semibold">Rekap Konversi Konsultan</div>
        <div className="w-44 ml-auto"><Input type="month" data-testid="kons-recap-month" value={month} onChange={(e) => setMonth(e.target.value)} /></div>
      </div>
      <p className="text-xs text-slate-500 mb-3">Tamu = kunjungan yang ditangani bulan ini. Quotation/Order dihitung dari quotation yang dibuat bulan ini; bila tamu berganti konsultan karena tidak hadir, nilai dibagi rata; bila takeover, nilai pindah ke yang menangani.{d?.unassigned ? ` ${d.unassigned} kunjungan belum ada konsultannya.` : ""}</p>
      <Table testid="kons-recap-table" columns={["Konsultan", "Tamu", "Jadi Quotation", "Jadi Order", "Konversi"]} rows={d?.rows || []} renderRow={(r) => (
        <tr key={r.email} className="border-t border-slate-100" data-testid={`kons-recap-${r.email}`}>
          <td className="px-4 py-3">{r.name}</td>
          <td className="px-4 py-3">{r.guests}</td>
          <td className="px-4 py-3">{fmt(r.quote)}</td>
          <td className="px-4 py-3 text-emerald-700">{fmt(r.order)}</td>
          <td className="px-4 py-3">{r.rate}%</td>
        </tr>
      )} />
    </Card>
  );
};
